import React from 'react'

const ContactSection = () => {
    return (
        <section id="contact" className="contact section">
            <div className="container section-title" data-aos="fade-up">
                <h2>Contactanos</h2>
                <p>Cuentanos tu idea, problema o necesidades, nosotros te atenderemos a la brevedad</p>
            </div>

            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row gy-4">
                    <div className="col-lg-5">
                        <div className="info-wrap">
                            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
                                <i className="bi bi-geo-alt flex-shrink-0"></i>
                                <div>
                                    <h3>Ubicacion</h3>
                                    <p>Region de Coquimbo,Chile</p>
                                </div>
                            </div>
                            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
                                <i className="bi bi-telephone flex-shrink-0"></i>
                                <div>
                                    <h3>Telefono</h3>
                                    <p>+56966313511</p>
                                </div>
                            </div>
                            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
                                <i className="bi bi-envelope flex-shrink-0"></i>
                                <div>
                                    <h3>Correo electronico</h3>
                                    <p>stackcoding.service@gmail.com</p>
                                </div>
                            </div>
                            <iframe title='mapContact' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1242675.2174773912!2d-71.31719825806567!3d-30.649798551653614!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96893835f8510297%3A0x85982eeec5cf03a1!2sCoquimbo!5e0!3m2!1sen!2scl!4v1731372158126!5m2!1sen!2scl" style={{ border: 0, width: "100%", height: "290px" }}></iframe>
                        </div>
                    </div>

                    <div className="col-lg-7">
                        <form action="" method="post" className="php-email-form" data-aos="fade-up" data-aos-delay="200">
                            <div className="row gy-4">
                                <div className="col-md-6">
                                    <label htmlFor="name-field" className="pb-2">Tu nombre</label>
                                    <input type="text" name="name" id="name-field" className="form-control" required="" />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="email-field" className="pb-2">Tu correo electronico</label>
                                    <input type="email" className="form-control" name="email" id="email-field" required="" />
                                </div>
                                <div className="col-md-12">
                                    <label htmlFor="subject-field" className="pb-2">Asunto</label>
                                    <input type="text" className="form-control" name="subject" id="subject-field" required="" />
                                </div>
                                <div className="col-md-12">
                                    <label htmlFor="message-field" className="pb-2">Mensaje</label>
                                    <textarea className="form-control" name="message" rows="10" id="message-field" required=""></textarea>
                                </div>
                                <div className="col-md-12 text-center">
                                    <div className="loading">Loading</div>
                                    <div className="error-message"></div>
                                    <div className="sent-message">Your message has been sent. Thank you!</div>
                                    <button type="submit" disabled>Enviar mensaje</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactSection